function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M285.594 128.408C299.913 117.067 310.031 106.327 315.793 102.825C328.128 109.68 338.134 124.13 345.952 140.065L383.359 120.382C363.375 98.2927 342.772 93.159 321.936 81.2208C309.168 85.5875 295.505 89.1388 281.44 92.0254C286.901 107.257 286.693 120.331 285.594 128.408V128.408Z",
  fill: "#5A3CB4"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.7924 122.876C45.7924 122.876 36.4315 187.604 64.4675 187.399C92.5041 187.192 90.9417 187.405 90.9417 187.405L68.0776 117.728L45.7924 122.876Z",
  fill: "#BF76FC"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.9789 139.404L86.6887 127.269C90.9532 126.371 93.6837 122.19 92.7861 117.926V117.923L80.4946 59.4724L15.0625 73.2322L28.9789 139.404Z",
  fill: "#FFA012"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.8179 92.3354C83.3629 91.3813 86.2749 86.929 85.319 82.3886L78.8718 51.77C77.9133 47.2296 73.4535 44.3217 68.9104 45.2787C64.3648 46.2327 61.454 50.6879 62.4093 55.2285L68.8558 85.8444C69.8118 90.3848 74.269 93.2926 78.8146 92.3382L78.8179 92.3354Z",
  fill: "#F9CB3F"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.2864 119.077C26.6165 130.168 35.8836 137.606 44.9813 135.691C54.0803 133.777 59.5795 123.229 57.2403 112.142C54.9011 101.057 45.6404 93.6165 36.5415 95.5306C27.4458 97.4449 21.9524 107.987 24.2864 119.077Z",
  fill: "#F89310"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.3688 95.7984C66.9103 94.8415 69.8217 90.3868 68.8634 85.8491L68.8601 85.8376L60.7688 47.3888C59.8111 42.8483 55.3542 39.9406 50.8095 40.8947C46.2648 41.8488 43.3572 46.3011 44.3123 50.8416L52.4063 89.3046C53.3621 93.845 57.8209 96.7528 62.3662 95.7985L62.3688 95.7984Z",
  fill: "#F9CB3F"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.9178 99.2567C50.4621 98.3024 53.372 93.8498 52.417 89.309L52.4144 89.3063L45.096 54.5335C44.1423 49.9929 39.6826 47.0848 35.1422 48.0389C30.5966 48.993 27.6867 53.4457 28.6417 57.9867L35.9626 92.765C36.9176 97.303 41.3761 100.211 45.9178 99.2567Z",
  fill: "#F9CB3F"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.1066 99.8198L27.2749 99.5644C32.8367 98.4054 36.4041 92.9571 35.2423 87.3957L35.2397 87.3757L21.5508 22.3173C20.3779 16.7583 14.9207 13.2048 9.361 14.378L8.19135 14.6311C2.62963 15.7955 -0.935879 21.2463 0.226637 26.8081L0.229245 26.825L13.9201 91.8665C15.0884 97.4283 20.5423 100.987 26.1014 99.8198L26.1066 99.8198Z",
  fill: "#F9CB3F"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.5405 139.485L45.0551 136.014L32.6933 77.2459C32.2553 75.2008 30.2445 73.8915 28.1967 74.3232C16.9697 76.6835 9.78111 87.6953 12.1429 98.9202V98.9229L19.4237 133.548C20.3076 137.701 24.3837 140.359 28.5405 139.485V139.485Z",
  fill: "#F89310"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.008 121.433C109.146 127.028 116.113 131.915 122.919 136.197C121.641 125.314 122.223 114.29 124.688 103.598C106.124 103.209 93.4959 102.43 90.4764 102.325C79.0972 107.616 69.7979 115.847 62.1996 125.718L83.0172 140.621C88.8884 126.059 97.6621 121.873 102.008 121.433H102.008Z",
  fill: "#5A3CB4"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M238.882 152.497C238.092 165.366 237.955 176.973 238.353 187.403H266.841C259.165 163.666 252.329 141.137 252.329 141.137C246.548 143.054 241.732 147.122 238.882 152.497H238.882Z",
  fill: "#E49963"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M238.882 152.497C238.092 165.366 237.955 176.973 238.353 187.403H266.841C259.165 163.666 252.329 141.137 252.329 141.137C246.548 143.054 241.732 147.122 238.882 152.497H238.882Z",
  fill: "#E49963"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M249.696 87.0606C212.484 69.1932 175.272 99.4882 138.06 56.3085C147.154 38.2169 155.177 19.6112 162.095 0.58206C199.306 16.9323 236.519 -14.0043 273.729 29.414C265.721 45.77 257.706 65.3896 249.696 87.0606L249.696 87.0606Z",
  fill: "#5A3CB4"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M264.129 50.4817C226.923 18.6239 189.717 50.6494 152.511 24.9508C154.26 20.7452 156.011 16.4064 157.76 11.9395C194.966 32.2997 232.172 0.651999 269.378 38.6036C267.631 42.4231 265.881 46.3814 264.129 50.4817L264.129 50.4817Z",
  fill: "#F9CB3F"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M254.031 75.5181C216.825 53.8551 179.619 85.1149 142.414 47.6089C144.163 43.9712 145.913 40.1775 147.663 36.2247C184.868 67.3536 222.075 35.4375 259.279 62.1644C257.53 66.4981 255.781 70.9515 254.031 75.5181Z",
  fill: "#F9CB3F"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M227.054 123.65C236.96 113.113 236.084 120.305 239.003 123.298C247.244 131.763 242.482 115.725 246.392 112.55C249.861 109.734 257.571 126.622 252.802 142.672L239.335 153.636C226.144 152.209 213.795 139.382 227.054 123.65H227.054Z",
  fill: "#E49963"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M215.73 175.42L215.095 175.162C213.316 174.432 212.464 172.398 213.188 170.617L271.528 29.078C272.261 27.2996 274.292 26.4476 276.072 27.1721L276.706 27.4306C278.488 28.1605 279.34 30.1945 278.613 31.9753L220.27 173.514C219.54 175.292 217.512 176.145 215.73 175.42L215.73 175.42Z",
  fill: "#BF76FF"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M335.998 95.9857C335.872 95.614 335.711 95.4181 335.767 95.069C335.674 95.0548 335.586 95.1172 335.571 95.2137L335.568 95.2163C332.519 96.7407 329.066 96.068 328.141 93.8256C328.018 93.4539 327.888 93.0792 327.766 92.7074C325.872 93.0906 323.935 92.2564 322.916 90.613C322.641 89.9884 322.553 89.2988 322.661 88.6262C320.611 89.1339 318.476 88.1777 317.49 86.3071C316.514 83.7952 317.755 80.9684 320.268 79.989L320.329 79.9664C322.644 78.6721 325.565 79.3902 327.014 81.6098C327.297 82.169 327.397 82.8018 327.297 83.4204C329.632 82.2824 332.445 82.9749 333.982 85.0641L334.356 86.1797C336.253 85.7961 338.187 86.6306 339.206 88.2741C339.464 88.8417 339.563 89.4662 339.493 90.0848C341.253 89.5882 343.124 90.3632 344.019 91.9583C344.808 94.0783 343.772 96.4425 341.679 97.3027C339.731 98.4212 337.249 97.8477 335.998 95.9857H335.998Z",
  fill: "#E49963"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.0371 118.417C77.1585 118.121 77.2039 117.797 77.1669 117.479C77.2604 117.456 77.3539 117.51 77.3798 117.604V117.61C80.5639 118.82 83.9323 117.814 84.6243 115.472L84.8853 114.335C86.8126 114.525 88.651 113.496 89.4968 111.757C89.7039 111.111 89.724 110.421 89.5481 109.767C91.6455 110.066 93.6708 108.891 94.4602 106.925C95.1781 104.321 93.6546 101.626 91.0522 100.907L90.9983 100.893C88.5666 99.838 85.7344 100.847 84.5172 103.206C84.2952 103.792 84.2615 104.434 84.4225 105.04C81.9914 104.139 79.2617 105.111 77.942 107.351L77.6778 108.488C75.7537 108.297 73.9147 109.326 73.0669 111.066C72.8683 111.657 72.8332 112.291 72.9728 112.899C71.174 112.584 69.3915 113.545 68.6625 115.222C68.0919 117.416 69.3603 119.665 71.5285 120.31C73.5778 121.219 75.9783 120.395 77.0371 118.417L77.0371 118.417Z",
  fill: "#E49963"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M120.048 187.404C118.441 170.191 117.749 154.955 117.453 145.42C120.309 127.528 107.993 108.61 106.372 106.935C102.187 102.572 100.488 100.262 99.6025 100.56C98.7166 100.859 94.0837 103.926 99.9695 110.468C104.71 115.734 107.68 125.733 101.999 121.424C96.6414 120.483 89.2709 128.88 86.1163 133.328C90.5426 138.994 96.1985 143.545 102.615 146.755C100.255 155.367 96.4544 170.756 94.2532 187.404L120.048 187.404Z",
  fill: "#E49963"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M340.103 187.404C335.818 160.663 326.605 134.469 324.203 127.917C326.538 125.739 327.839 119.701 329.913 114.816C330.536 113.4 320.818 105.286 315.781 102.832C313.099 105.638 312.522 99.7793 314.36 94.6166C317.131 86.8607 312.024 85.8554 311.149 85.9124C310.28 85.9691 309.634 88.5706 307.56 93.8383C306.76 95.8633 301.698 116.961 310.583 131.432L310.592 131.43C311.187 142.806 311.973 163.958 311.3 187.404L340.103 187.404Z",
  fill: "#E49963"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M138.199 144.9C145.572 148.68 152.737 151.745 159.686 154.136C159 137.175 160.541 120.202 164.284 103.633C156.278 103.792 148.671 103.835 141.59 103.806C138.478 114.289 138.091 133.173 138.199 144.9Z",
  fill: "#5A3CB4"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M353.96 158.605C355.797 163.431 357.441 168.172 358.901 172.683C376.624 176.686 395.199 173.986 411.047 165.115C406.753 155.514 402.423 147.313 398.055 140.224C380.264 156.871 363.058 158.957 353.96 158.605V158.605Z",
  fill: "#5A3CB4"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M177.003 158.874C187.8 161.07 198.014 161.703 207.641 161.146C209.169 148.278 212.133 120.206 211.405 101.418C200.801 102.228 190.426 102.79 180.479 103.168C178.868 114.133 175.831 138.435 177.003 158.874Z",
  fill: "#5A3CB4"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M230.439 155.174C230.143 156.077 229.836 156.921 229.524 157.73C243.479 154.163 255.89 148.29 266.735 141.65C269.326 119.355 263.341 103.193 259.764 95.9224C250.392 97.385 240.952 98.5947 231.581 99.589C233.549 110.708 236.798 135.816 230.439 155.174Z",
  fill: "#5A3CB4"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.0467 154.763C68.8594 153.544 59.2478 149.472 51.2546 143.057C47.0963 151.063 43.6799 159.545 40.8847 168.046C51.9505 175.169 68.0381 176.961 77.1729 177.382C77.1989 168.563 77.8915 161.09 79.0467 154.763Z",
  fill: "#5A3CB4"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M358.894 172.693C360.616 178.018 362.072 183.001 363.277 187.405H420C417.037 179.236 414.055 171.846 411.053 165.124C395.2 173.996 376.622 176.696 358.894 172.693V172.693Z",
  fill: "#F9CB3F"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M353.946 158.598C363.045 158.951 380.253 156.863 398.044 140.21C393.191 132.329 388.295 125.829 383.36 120.376L345.952 140.051C348.936 146.132 351.595 152.422 353.946 158.598L353.946 158.598Z",
  fill: "#F9CB3F"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.1759 177.362C68.0427 176.942 51.9559 175.15 40.8912 168.029C38.7498 174.547 36.9749 181.072 35.4949 187.403H77.428C77.2519 183.883 77.1668 180.529 77.1759 177.362V177.362Z",
  fill: "#F9CB3F"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M83.0237 140.616L62.2062 125.728C58.0796 131.087 54.4604 136.937 51.274 143.057C59.2667 149.466 68.8785 153.534 79.0667 154.752C80.0809 149.202 81.4441 144.53 83.0237 140.616V140.616Z",
  fill: "#F9CB3F"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M122.915 136.181C128.109 139.442 133.2 142.339 138.198 144.898C138.09 133.17 138.476 114.284 141.59 103.8C135.544 103.78 129.884 103.7 124.685 103.592C122.219 114.281 121.636 125.302 122.915 136.181Z",
  fill: "#F9CB3F"
});
var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M266.743 141.667C273.668 137.419 279.953 132.87 285.585 128.408C286.684 120.33 286.892 107.253 281.432 92.0192C274.296 93.4827 267.059 94.7758 259.775 95.9151C263.35 103.189 269.333 119.361 266.743 141.667Z",
  fill: "#F9CB3F"
});
var _ref34 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M207.626 161.141C215.301 160.695 222.604 159.502 229.522 157.732C229.835 156.923 230.142 156.079 230.438 155.176C236.799 135.816 233.549 110.704 231.58 99.5841C224.794 100.303 218.052 100.91 211.391 101.419C212.118 120.205 209.154 148.274 207.626 161.141Z",
  fill: "#F9CB3F"
});
var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.691 154.156C165.625 156.198 171.394 157.743 177.014 158.885C175.842 138.449 178.879 114.15 180.49 103.187C174.943 103.394 169.534 103.548 164.292 103.65C160.547 120.22 159.004 137.194 159.691 154.156Z",
  fill: "#F9CB3F"
});
function SvgFans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 188,
    viewBox: "0 0 420 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFans);
export default __webpack_public_path__ + "static/media/fans.8c49c5da1c30fbd7e0f6bf7ad4ff4bc9.svg";
export { ForwardRef as ReactComponent };